'use strict';

var template      = require('employer/templates/payroll/Layout.html');
var PayrollView   = require('./stepOne/Payroll');
var StepTwoView   = require('./stepTwo/Main');
var StepThreeView = require('./stepThree/Main');
import moment from 'moment';
import Payroll from 'newModels/payroll.js';
import PayrollDetails from 'newCollections/payroll-details.js';

module.exports = Backbone.View.extend({
    contentView: null,
    loaderMessages: [
        `Tabulating some serious data... Don't leave us yet!`,
        `Most companies run payroll around the 25-30th of each month. But you \
        can run payroll as early as the 16th of each month with our app.`,
        `Small businesses spend up to ten hours processing payroll a month. \
        Thank goodness you've got PayrollPanda!`,
        `If you're looking for ways to go green, cut costs, and maintain the \
        security of your data – go paperless!<br>Paperless payroll will save \
        you time too!`,
        `Facing any issue? The fastest way to reach customer support is via \
        the live chat at the bottom right corner of the app.`,
        `Employees have 24/7 access to their payslips and leave management if \
        they're on the app. Get them on board now if you haven't already!`,
        `Did you know that Directors' Fees are exempt from EPF, SOCSO and EIS?`,
        `Don't forget to enter your employees' previous payslips information \
        for accurate PCB calculations!`,
        `Keep records of travel for 7 years and your employees can claim full \
        tax exemption for their travel allowance.`
    ],

    events: {
        'click .js-fullscreen-toggle': 'fullscreenToggle',
        'changeDate .js-datepicker-periodDate': 'updatePeriodDate'
    },

    initialize: function(options) {
        //FIXME NEVER extend this with options!!!!
        _.extend(this, options);
    },

    render: function() {
        this.$el.html(template({
            period: this.model ? this.model.getPeriodFormatted() : '',
            periodDate: this.model ?
                this.model.getPeriod().format('MM/YYYY') : '',
            editablePeriodDate: (
                this.step === 1 && app.user.isAdmin()
            )
        }));

        this.$('.js-datepicker').datepicker({
            autoclose: true,
            format: 'mm/yyyy',
            keyboardNavigation: false,
            todayBtn: 'linked',
            todayHighlight: true,
            minViewMode: 'months',
            monthsstartView: 'months'
        });

        this.setStep();

        return this;
    },

    renderContent: function(options) {
        this.render();

        if (this.contentView !== null) {
            this.contentView.remove();
            this.contentView = null;
        }

        options = _.extend(options || {}, {
            layoutView: this
        });

        if (this.step == 1) {
            this.contentView = new PayrollView(options);
        } else if (this.step == 2) {
            this.contentView = new StepTwoView(options);
        } else if (this.step == 3) {
            this.contentView = new StepThreeView(options);
        }

        this.$('#content').html('').append(this.contentView.$el);
        this.$('#loader').hide();
    },

    updatePeriodDate: function(ev) {
        let $datepicker = this.$(ev.currentTarget);
        let options;
        if (this.contentView) {
            options = this.contentView.options;
        }
        let date = moment($datepicker.datepicker('getDate'))
            .startOf('month')
            .add(1, 'day')
            .toDate();
        this.model.set('periodDate', date);
        if (options) {
            return Promise.all([
                app.company.fetchPayableEmployees(null, 10, date),
                app.company.fetchPayableEmployees(null, null, date),
                this.model.destroy()
            ]).then(([employees, allEmployees]) => {
                this.model = new Payroll({
                    companyId: app.company.id,
                    periodDate: date
                });
                options.employees = employees;
                options.allEmployees = allEmployees;
                return PayrollDetails.createDefaults(
                    this.model, options.employees.slice(0, 10)
                );
            }).then(details => {
                options.payrollDetails = details;
                options.model = this.model;
                this.showLoader();
                this.contentView.remove();
                this.contentView = null;
                this.contentView = new PayrollView(options);
                this.$('#content').html('').append(this.contentView.$el);
                this.hideLoader();
            });
        }
    },

    fullscreenToggle: function(e) {
        if ($('nav.navbar-default').is(':visible') && e) {
            $('.js-fullscreen-toggle').addClass('btn-success');
            $('.js-fullscreen-toggle').removeClass('btn-white');
            $('nav.navbar-default').hide();
            $('#page-wrapper').css('margin-left', '0px');
        } else {
            $('.js-fullscreen-toggle').removeClass('btn-success');
            $('.js-fullscreen-toggle').addClass('btn-white');
            $('#page-wrapper').css('margin-left', '');
            setTimeout(function() {
                $('nav.navbar-default').show();
            }, 350);
        }
    },

    setStep: function() {
        var $tabs = this.$('li[role="tab"]');
        $tabs.removeClass('current');
        $tabs.slice(0, this.step - 1).addClass('done');
        $tabs.eq(this.step - 1).addClass('current');

        if (this.step != 2) {
            $('.js-fullscreen-toggle').hide();
            this.fullscreenToggle();
        } else {
            $('.js-fullscreen-toggle').show();
        }
    },

    showLoader: function(withMessages) {
        this.$('.js-loader-message').html('');

        this.$('#content').hide();
        this.$('#loader').show();

        if (withMessages === true) {
            this.$('.js-loader-message').html(this.loaderMessages[0]);

            this.loaderMessagesTimer = setInterval(function() {
                this.$('.js-loader-message').html(
                    _.sample(this.loaderMessages)
                );
            }.bind(this), 5000);
        }
    },

    hideLoader: function() {
        if (this.loaderMessagesTimer) {
            clearTimeout(this.loaderMessagesTimer);
        }

        this.$('#content').show();
        this.$('#loader').hide();
    },

    undelegateEvents: function() {
        Backbone.View.prototype.undelegateEvents.apply(this, arguments);

        if (this.contentView) {
            this.contentView.remove();
            this.contentView = null;
        }
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/payroll/Layout.js